import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LegacyMainLayout from 'layouts/MainLayout';
import MainLayoutV2 from 'layouts/MainLayoutV2';
import { USE_NEW_SHELL } from 'core/flags';
import { NotFoundPage } from 'modules/not-found';
import ProtectedRoute from './ProtectedRoute';
import { routes } from './routes';

const MainLayout = USE_NEW_SHELL ? MainLayoutV2 : LegacyMainLayout;

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public auth routes */}
        {routes
          .filter((route) => route.public)
          .map((route) => (
            <Route key={route.path} path={route.path} element={<route.component />} />
          ))}

        {/* Standalone routes — без MainLayout (OAuth-попапы, etc.) */}
        {routes
          .filter((route) => route.standalone)
          .map((route) => (
            <Route key={route.path} path={route.path} element={<route.component />} />
          ))}

        {/* Redirect root to chat */}
        <Route path="/" element={<Navigate to="/chat" replace />} />

        {/* Protected routes with MainLayout */}
        {routes
          .filter((route) => !route.public && !route.standalone && route.path !== '/')
          .map((route) =>
            route.nested ? (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <MainLayout>
                    <ProtectedRoute
                      permission={route.permission}
                      adminOnly={route.adminOnly}
                      requiredPermission={route.requiredPermission}
                    >
                      <route.component />
                    </ProtectedRoute>
                  </MainLayout>
                }
              >
                <Route index element={<Navigate to={route.nested[0].path} replace />} />
                {route.nested.map((nested) => (
                  <Route key={nested.path} path={nested.path} element={<nested.component />} />
                ))}
              </Route>
            ) : (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <MainLayout>
                    <ProtectedRoute
                      permission={route.permission}
                      adminOnly={route.adminOnly}
                      requiredPermission={route.requiredPermission}
                    >
                      <route.component />
                    </ProtectedRoute>
                  </MainLayout>
                }
              />
            )
          )}

        {/* Catch all route - 404 page (outside MainLayout) */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
